module.exports = __webpack_public_path__ + "img/qwello-stations-iphone@2x.ad3dba37.webp";